<script setup lang="ts">
import { navigateTo } from 'nuxt/app'

const props = defineProps<{
  title?: string
  placeholder?: string
  button: StoryBlokButton[]
  secondaryButton?: StoryBlokButton[]
  mask: { mask: string | RegExp }
  countryCode: string
  text?: StoryBlokRichText
  image?: StoryBlokImage
  textTooltip?: StoryBlokTooltip[]
  hideInput?: boolean
}>()

const emit = defineEmits(['click'])
const form = ref()

const primaryLink = ref(props.button[0].link?.url)
</script>

<template>
  <FormSimple
    ref="form"
    class="w-full relative bg-white tile_shadow p-4 rounded-2xl flex flex-col justify-center overflow-hidden md:p-5 lg:min-h-[220px] xl:min-h-[200px]"
    @submit="hideInput ? navigateTo(primaryLink, { external: true }) : emit('click', form?.values?.licensePlate || 'nospz')"
  >
    <StoryblokImage
      v-if="image?.filename"
      class="absolute top-4 right-4 <xs:w-max-[90px] <xs:mx-0 xs:max-w-[130px] sm:max-w-[250px] <md:hidden md:top-5 md:right-5 xl:max-w-[300px]"
      :src="image"
    />

    <div class="flex flex-col gap-3 justify-center xl:justify-between xl:h-full">
      <div class="flex flex-col gap-1.5 @lg:w-1/2">
        <h3 v-html="title" />
        <div class="flex gap-1 z-10">
          <StoryblokRichText :document="text" />
          <BaseTooltip v-if="textTooltip?.length" v-bind="textTooltip[0]" />
        </div>
      </div>
      <FormFieldText
        v-if="!hideInput"
        disable-storyblok
        :placeholder="placeholder"
        :mask="mask"
        name="licensePlate"
        class="text-secondary w-full h-full rounded-xl overflow-hidden focus:outline-none md:max-w-1/2"
      >
        <template #start>
          <div class="bg-[#003399] flex items-center justify-center px-2 py-2.5">
            <div class="flex-col items-center">
              <nuxt-icon name="core/euStars" filled class="text-xs" />
              <div class="text-white text-[12px] pt-0.5">
                {{ props.countryCode }}
              </div>
            </div>
          </div>
        </template>
      </FormFieldText>
      <div class="flex flex-col gap-3 md:flex-row">
        <StoryblokButton v-bind="button[0]" submit />
        <StoryblokButton v-if="secondaryButton?.length" v-bind="secondaryButton[0]" />
      </div>
    </div>
  </FormSimple>
</template>

<style scoped lang="scss">
.tile_shadow {
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
}
</style>
